import { useEarlyAccessInteractor } from '../interactor/useEarlyAccessInteractor';
import { EarlyAccessView } from '../view/EarlyAccessView';

/**
 * Presenter (Controller) for Early Access Section
 * Connects the Interactor (business logic) with the View (UI)
 */
export const EarlyAccessPresenter = () => {
  const { showForm, setShowForm, formData, updateFormField, isSubmitting, message, handleRegister } =
    useEarlyAccessInteractor();

  const handleFieldChange = (field) => (e) => {
    updateFormField(field, e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleRegister();
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  return (
    <EarlyAccessView
      showForm={showForm}
      formData={formData}
      onFieldChange={handleFieldChange}
      onSubmit={handleSubmit}
      onShowForm={handleShowForm}
      isSubmitting={isSubmitting}
      message={message}
    />
  );
};

export default EarlyAccessPresenter;
